import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '45%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginTop: 16,
    marginBottom: 16,
  },
  labelContainer: {
    display: 'flex',
    flex: 1,
    marginBottom: -32,
  },
  input: {
    width: '100%',
    borderRadius: 16,
    backgroundColor: 'rgba(195, 155, 225, 0.2)',
    '&:hover': {
      borderColor: '#7030A0',
    },
    '& .Mui-disabled': {
      backgroundColor: theme.palette.background.default,
      borderRadius: 16,
    },
    '& input': {
      textAlign: 'flex-start',
      fontSize: 14,
      fontWeight: 'bold',
    },
    '& input::placeholder': {
      color: 'rgba(0,0,0,1)',
      fontWeight: 'bold',
      fontSize: 12,
      textAlign: 'center',
    },
    '& .MuiOutlinedInput-input': {
      borderWidth: 0,
    },
    '& .MuiOutlinedInput-input:focus': {
      // backgroundColor: '#FF0',
    },
    '& .Mui-focused': {
      border: 'none',
    },
  },
  label: {
    fontWeight: 'bold',
    paddingLeft: 4,
  },
}));
